import z from 'zod';
import { ANON_ID_LOCAL_KEY } from './constants';

export function isUUIDChecker(inpt: string): boolean {
  const schema = z.string().uuid();

  const parsingResult = schema.safeParse(inpt);

  if (!parsingResult.success) {
    return false;
  }

  return true;
}

/**
 * Known nuances. If user empty localStorage you can't retrive it.
 * Then it will be lost forever.
 *
 * Until email it's risky.
 *
 * After email we can do something
 * @returns UUID string
 */
export const getAnonId = (): string => {
  const anonID = localStorage.getItem(ANON_ID_LOCAL_KEY);
  const isValidUUID = isUUIDChecker(anonID ?? '');

  if (!isValidUUID || !anonID) {
    const newUUID = crypto.randomUUID();
    localStorage.setItem(ANON_ID_LOCAL_KEY, newUUID);
    return newUUID;
  }

  return anonID;
};
